// // OrderHistoryPage.jsx
// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Modal } from 'react-bootstrap';
// import './orderhistory.scss';
// import FurnitureNavbar from '../../../../components/layout/Nav';
// import withAuth from '../../../auth/WithAuth';
// import { serverUrlAuth } from '../../../../serverUrl';
// import { toast } from 'react-toastify';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
// import {
//   FaBox,
//   FaCheckCircle,
//   FaTimesCircle,
//   FaClock,
//   FaSpinner,
//   FaCalendar,
//   FaMoneyBillWave,
//   FaSearch,
//   FaDownload,
//   FaEye,
//   FaReceipt,
//   FaShoppingBag,
// } from 'react-icons/fa';

// const OrderHistoryPage = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [orders, setOrders] = useState([]);
//   const [filter, setFilter] = useState('all');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [modalLoading, setModalLoading] = useState(false);
//   const [pdfLoading, setPdfLoading] = useState(false);
//   const [downloadingOrderId, setDownloadingOrderId] = useState(null);

//   useEffect(() => {
//     fetchOrderHistory();
//   }, []);

//   const fetchOrderHistory = async () => {
//     try {
//       setLoading(true);
//       const response = await serverUrlAuth.get('checkout/history/');
//       console.log('Order history:', response.data);
//       setOrders(response.data.orders || []);
//     } catch (error) {
//       console.error('Error fetching order history:', error);
//       toast.error('Failed to load order history');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchOrderDetails = async (orderId) => {
//     try {
//       setModalLoading(true);
//       const response = await serverUrlAuth.get(`checkout/${orderId}/status/`);
//       setSelectedOrder(response.data);
//       setShowModal(true);
//     } catch (error) {
//       console.error('Error fetching order details:', error);
//       toast.error('Failed to load order details');
//     } finally {
//       setModalLoading(false);
//     }
//   };

//   const getStatusBadge = (status, isPaid) => {
//     if (isPaid) {
//       return (
//         <span className="status-badge success">
//           <FaCheckCircle /> Paid
//         </span>
//       );
//     }
//     switch (status) {
//       case 'pending':
//         return (
//           <span className="status-badge pending">
//             <FaClock /> Pending
//           </span>
//         );
//       case 'failed':
//         return (
//           <span className="status-badge failed">
//             <FaTimesCircle /> Failed
//           </span>
//         );
//       case 'refunded':
//         return (
//           <span className="status-badge refunded">
//             <FaClock /> Refunded
//           </span>
//         );
//       default:
//         return <span className="status-badge secondary">{status}</span>;
//     }
//   };

//   const getFilteredOrders = () => {
//     let filtered = orders;

//     if (filter === 'paid') {
//       filtered = filtered.filter((o) => o.is_paid);
//     } else if (filter === 'pending') {
//       filtered = filtered.filter(
//         (o) => o.payment_status === 'pending' && !o.is_paid,
//       );
//     } else if (filter === 'failed') {
//       filtered = filtered.filter((o) => o.payment_status === 'failed');
//     }

//     if (searchTerm) {
//       filtered = filtered.filter((o) => {
//         const productName = o.items?.[0]?.product_name?.toLowerCase() || '';
//         const ref = o.reference?.toLowerCase() || '';
//         const id = o.id?.toString() || '';
//         const search = searchTerm.toLowerCase();
//         return (
//           productName.includes(search) ||
//           ref.includes(search) ||
//           id.includes(search)
//         );
//       });
//     }

//     return filtered;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-KE', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//     });
//   };

//   const formatCurrency = (amount) => {
//     return `KSh ${Number(amount).toLocaleString()}`;
//   };

//   const getProductName = (items) => {
//     if (!items || items.length === 0) return 'Order';
//     return items[0].product_name || 'Order';
//   };

//   const getTotalItems = (items) => {
//     if (!items) return 0;
//     return items.reduce((sum, item) => sum + item.quantity, 0);
//   };

//   const viewReceipt = (orderId) => {
//     window.open(`checkout/${orderId}/receipt/`, '_blank');
//   };

//   const downloadReceipt = (orderId) => {
//     window.open(`checkout/${orderId}/download-receipt/`, '_blank');
//   };

//   const resendReceipt = async (orderId) => {
//     try {
//       const response = await serverUrlAuth.post(`checkout/${orderId}/receipt/`);
//       if (response.status === 200) {
//         toast.success('Receipt resent successfully!');
//       } else {
//         toast.error('Failed to resend receipt');
//       }
//     } catch (error) {
//       console.error('Error resending receipt:', error);
//       toast.error('Failed to resend receipt');
//     }
//   };

//   // ✅ Download PDF - works from the order card
//   const downloadPDF = async (orderId) => {
//     if (!orderId) {
//       toast.error('No order selected. Please try again.');
//       return;
//     }

//     setDownloadingOrderId(orderId);
//     setPdfLoading(true);

//     try {
//       // Fetch the complete receipt HTML from backend
//       const response = await serverUrlAuth.get(
//         `checkout/${orderId}/receipt/`,
//       );

//       // Create a hidden container
//       const container = document.createElement('div');
//       container.innerHTML = response.data;
//       container.style.position = 'fixed';
//       container.style.left = '-9999px';
//       container.style.top = '-9999px';
//       container.style.width = '800px';
//       container.style.background = '#ffffff';
//       container.style.zIndex = '-1000';
//       container.style.padding = '20px';

//       document.body.appendChild(container);

//       // Wait for images to load
//       const images = container.querySelectorAll('img');
//       await Promise.all(
//         Array.from(images).map((img) => {
//           return new Promise((resolve) => {
//             if (img.complete) {
//               resolve();
//             } else {
//               img.onload = resolve;
//               img.onerror = resolve;
//             }
//           });
//         }),
//       );

//       // Convert to canvas
//       const canvas = await html2canvas(container, {
//         scale: 2,
//         useCORS: true,
//         backgroundColor: '#ffffff',
//         logging: false,
//         allowTaint: true,
//       });

//       // Generate PDF
//       const imgData = canvas.toDataURL('image/jpeg', 1);
//       const pdf = new jsPDF({
//         unit: 'px',
//         format: [canvas.width, canvas.height],
//       });

//       pdf.addImage(
//         imgData,
//         'JPEG',
//         0,
//         0,
//         canvas.width,
//         canvas.height,
//         undefined,
//         'FAST',
//       );

//       const order = orders.find(o => o.id === orderId);
//       const receiptNumber = order?.receipt_number || orderId;
//       pdf.save(`receipt-${receiptNumber}.pdf`);

//       // Remove the temporary container
//       document.body.removeChild(container);
//       toast.success('PDF downloaded successfully!');
//     } catch (error) {
//       console.error('Error generating PDF:', error);
//       toast.error('Failed to generate PDF');
//     } finally {
//       setPdfLoading(false);
//       setDownloadingOrderId(null);
//     }
//   };

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="orders-loading">
//           <div className="loading-spinner"></div>
//           <p>Loading your orders...</p>
//         </div>
//       </>
//     );
//   }

//   const filteredOrders = getFilteredOrders();

//   const stats = {
//     total: orders.length,
//     paid: orders.filter((o) => o.is_paid).length,
//     pending: orders.filter((o) => o.payment_status === 'pending' && !o.is_paid)
//       .length,
//     failed: orders.filter((o) => o.payment_status === 'failed').length,
//     totalAmount: orders.reduce(
//       (sum, o) => sum + (o.is_paid ? parseFloat(o.total || 0) : 0),
//       0,
//     ),
//   };

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="orders-page-modern">
//         {/* Hero Section */}
//         <section className="orders-hero-modern">
//           <div className="hero-pattern"></div>
//           <div className="hero-content-modern">
//             <div className="welcome-badge">
//               <FaShoppingBag className="badge-icon" />
//               <span>Order History</span>
//             </div>
//             <h1 className="hero-title">
//               <span className="gradient-text">My</span>
//               <span className="hero-accent">Orders</span>
//             </h1>
//             <p className="hero-subtitle">
//               Track all your orders and purchases in one place. View receipts,
//               download invoices, and manage your order history.
//             </p>
//           </div>
//         </section>

//         {/* Stats Dashboard */}
//         <div className="stats-dashboard-modern">
//           <div className="stat-card-modern">
//             <div className="stat-icon-wrapper total">
//               <FaShoppingBag />
//             </div>
//             <div className="stat-content">
//               <h3>{stats.total}</h3>
//               <p>Total Orders</p>
//             </div>
//           </div>
//           <div className="stat-card-modern">
//             <div className="stat-icon-wrapper success">
//               <FaCheckCircle />
//             </div>
//             <div className="stat-content">
//               <h3>{stats.paid}</h3>
//               <p>Completed</p>
//             </div>
//           </div>
//           <div className="stat-card-modern">
//             <div className="stat-icon-wrapper pending">
//               <FaClock />
//             </div>
//             <div className="stat-content">
//               <h3>{stats.pending}</h3>
//               <p>Pending</p>
//             </div>
//           </div>
//           <div className="stat-card-modern">
//             <div className="stat-icon-wrapper total-amount">
//               <FaMoneyBillWave />
//             </div>
//             <div className="stat-content">
//               <h3>{formatCurrency(stats.totalAmount)}</h3>
//               <p>Total Spent</p>
//             </div>
//           </div>
//         </div>

//         {/* Controls Section */}
//         <div className="orders-controls-modern">
//           <div className="search-bar-modern">
//             <FaSearch className="search-icon" />
//             <input
//               type="text"
//               placeholder="Search by product, order ID, or reference..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//             {searchTerm && (
//               <button
//                 className="clear-search"
//                 onClick={() => setSearchTerm('')}
//               >
//                 ×
//               </button>
//             )}
//           </div>
//           <div className="filter-tabs-modern">
//             <button
//               className={`filter-tab ${filter === 'all' ? 'active' : ''}`}
//               onClick={() => setFilter('all')}
//             >
//               All
//             </button>
//             <button
//               className={`filter-tab ${filter === 'paid' ? 'active' : ''}`}
//               onClick={() => setFilter('paid')}
//             >
//               ✅ Completed
//             </button>
//             <button
//               className={`filter-tab ${filter === 'pending' ? 'active' : ''}`}
//               onClick={() => setFilter('pending')}
//             >
//               ⏳ Pending
//             </button>
//             <button
//               className={`filter-tab ${filter === 'failed' ? 'active' : ''}`}
//               onClick={() => setFilter('failed')}
//             >
//               ❌ Failed
//             </button>
//           </div>
//           <button className="refresh-btn-modern" onClick={fetchOrderHistory}>
//             <FaSpinner className={loading ? 'spinning' : ''} />
//             Refresh
//           </button>
//         </div>

//         {/* Orders Grid */}
//         <div className="orders-grid-modern">
//           {filteredOrders.length === 0 ? (
//             <div className="empty-state-modern full-width">
//               <div className="empty-icon">🛒</div>
//               <h3>No orders found</h3>
//               <p>
//                 {searchTerm || filter !== 'all'
//                   ? 'No orders match your search criteria'
//                   : "You haven't placed any orders yet"}
//               </p>
//               {!searchTerm && filter === 'all' && (
//                 <Link to="/shop" className="btn-primary-custom">
//                   Start Shopping
//                 </Link>
//               )}
//             </div>
//           ) : (
//             filteredOrders.map((order) => (
//               <div key={order.id} className="order-card-modern">
//                 <div className="order-card-header">
//                   <div className="order-product-section">
//                     <div className="product-icon-wrapper">
//                       <FaBox />
//                     </div>
//                     <div className="product-details">
//                       <h4>{getProductName(order.items)}</h4>
//                       <div className="order-meta">
//                         <span className="order-id">Order #{order.id}</span>
//                         <span className="divider">•</span>
//                         <span className="item-count">
//                           {getTotalItems(order.items)} item
//                           {getTotalItems(order.items) !== 1 ? 's' : ''}
//                         </span>
//                         <span className="divider">•</span>
//                         <span className="order-ref">
//                           {order.reference || 'N/A'}
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="order-status-badge">
//                     {getStatusBadge(order.payment_status, order.is_paid)}
//                   </div>
//                 </div>

//                 <div className="order-card-body">
//                   <div className="order-date-info">
//                     <FaCalendar />
//                     <span>{formatDate(order.created_at)}</span>
//                   </div>
//                   <div className="order-total-info">
//                     <span className="label">Total</span>
//                     <span className="amount">
//                       {formatCurrency(order.total)}
//                     </span>
//                   </div>
//                 </div>

//                 <div className="order-card-footer">
//                   <button
//                     className="btn-view"
//                     onClick={() => fetchOrderDetails(order.id)}
//                   >
//                     <FaEye /> View Details
//                   </button>
//                   {order.is_paid && (
//                     <button
//                       className="btn-pdf-download"
//                       onClick={() => downloadPDF(order.id)}
//                       disabled={pdfLoading && downloadingOrderId === order.id}
//                     >
//                       {pdfLoading && downloadingOrderId === order.id ? (
//                         <>
//                           <FaSpinner className="spinning" /> Generating...
//                         </>
//                       ) : (
//                         <>
//                           <FaDownload /> Download PDF
//                         </>
//                       )}
//                     </button>
//                   )}
//                 </div>
//               </div>
//             ))
//           )}
//         </div>

//         {/* Order Details Modal */}
//         <Modal
//           show={showModal}
//           onHide={() => {
//             setShowModal(false);
//             setSelectedOrder(null);
//           }}
//           centered
//           size="lg"
//           className="order-details-modal-modern"
//           backdrop="static"
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>
//               <span className="modal-title-icon">📋</span>
//               Order #{selectedOrder?.order_id}
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             {modalLoading ? (
//               <div className="modal-loading">
//                 <div className="spinner-small"></div>
//                 <p>Loading order details...</p>
//               </div>
//             ) : (
//               selectedOrder && (
//                 <div className="order-details-content">
//                   {/* Status */}
//                   <div className="detail-status-bar">
//                     {getStatusBadge(
//                       selectedOrder.payment_status,
//                       selectedOrder.is_paid,
//                     )}
//                     {selectedOrder.receipt_number && (
//                       <span className="receipt-number">
//                         <FaReceipt /> #{selectedOrder.receipt_number}
//                       </span>
//                     )}
//                   </div>

//                   {/* Order Info Grid */}
//                   <div className="detail-grid-modern">
//                     <div className="detail-item">
//                       <label>Order ID</label>
//                       <p>#{selectedOrder.order_id}</p>
//                     </div>
//                     <div className="detail-item">
//                       <label>Reference</label>
//                       <p>{selectedOrder.reference || 'N/A'}</p>
//                     </div>
//                     <div className="detail-item">
//                       <label>Date</label>
//                       <p>{formatDate(selectedOrder.created_at)}</p>
//                     </div>
//                     <div className="detail-item">
//                       <label>Status</label>
//                       <p>{selectedOrder.is_paid ? '✅ Paid' : '⏳ Pending'}</p>
//                     </div>
//                   </div>

//                   {/* Items */}
//                   <div className="detail-items-section">
//                     <h4>🛍️ Items Ordered</h4>
//                     <div className="items-table">
//                       <div className="items-header">
//                         <span>Product</span>
//                         <span>Qty</span>
//                         <span>Price</span>
//                         <span>Total</span>
//                       </div>
//                       {selectedOrder.items?.map((item, index) => (
//                         <div key={index} className="items-row">
//                           <span className="product-name">
//                             {item.product_name}
//                           </span>
//                           <span className="product-qty">{item.quantity}</span>
//                           <span className="product-price">
//                             {formatCurrency(item.price)}
//                           </span>
//                           <span className="product-total">
//                             {formatCurrency(item.total)}
//                           </span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>

//                   {/* Totals */}
//                   <div className="detail-totals">
//                     <div className="total-row">
//                       <span>Subtotal</span>
//                       <span>{formatCurrency(selectedOrder.subtotal)}</span>
//                     </div>
//                     <div className="total-row">
//                       <span>VAT (16%)</span>
//                       <span>{formatCurrency(selectedOrder.vat_amount)}</span>
//                     </div>
//                     <div className="total-row grand-total">
//                       <span>Total</span>
//                       <span>{formatCurrency(selectedOrder.total)}</span>
//                     </div>
//                   </div>

//                   {/* Shipping */}
//                   <div className="detail-shipping">
//                     <h4>📍 Shipping Address</h4>
//                     <p>{selectedOrder.shipping_address}</p>
//                     <p className="phone">📞 {selectedOrder.phone_number}</p>
//                   </div>
//                 </div>
//               )
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn-secondary"
//               onClick={() => {
//                 setShowModal(false);
//                 setSelectedOrder(null);
//               }}
//             >
//               Close
//             </button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default withAuth(OrderHistoryPage, 'client');


// src/pages/client/OrderHistory/OrderHistoryPage.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import './orderhistory.scss';
import Sidebar from '../../../../components/layout/Sidebar';
import withAuth from '../../../auth/WithAuth';
import { serverUrlAuth } from '../../../../serverUrl';
import { toast } from 'react-toastify';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {
  FaBox,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaSpinner,
  FaCalendar,
  FaMoneyBillWave,
  FaSearch,
  FaDownload,
  FaEye,
  FaReceipt,
  FaShoppingBag,
} from 'react-icons/fa';

const OrderHistoryPage = () => {
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [downloadingOrderId, setDownloadingOrderId] = useState(null);

  useEffect(() => {
    fetchOrderHistory();
  }, []);

  const fetchOrderHistory = async () => {
    try {
      setLoading(true);
      const response = await serverUrlAuth.get('checkout/history/');
      setOrders(response.data.orders || []);
    } catch (error) {
      console.error('Error fetching order history:', error);
      toast.error('Failed to load order history');
    } finally {
      setLoading(false);
    }
  };

  const fetchOrderDetails = async (orderId) => {
    try {
      setModalLoading(true);
      const response = await serverUrlAuth.get(`checkout/${orderId}/status/`);
      setSelectedOrder(response.data);
      setShowModal(true);
    } catch (error) {
      console.error('Error fetching order details:', error);
      toast.error('Failed to load order details');
    } finally {
      setModalLoading(false);
    }
  };

  const getStatusBadge = (status, isPaid) => {
    if (isPaid) {
      return (
        <span className="status-badge success">
          <FaCheckCircle /> Paid
        </span>
      );
    }
    switch (status) {
      case 'pending':
        return (
          <span className="status-badge pending">
            <FaClock /> Pending
          </span>
        );
      case 'failed':
        return (
          <span className="status-badge failed">
            <FaTimesCircle /> Failed
          </span>
        );
      case 'refunded':
        return (
          <span className="status-badge refunded">
            <FaClock /> Refunded
          </span>
        );
      default:
        return <span className="status-badge secondary">{status}</span>;
    }
  };

  const getFilteredOrders = () => {
    let filtered = orders;

    if (filter === 'paid') {
      filtered = filtered.filter((o) => o.is_paid);
    } else if (filter === 'pending') {
      filtered = filtered.filter(
        (o) => o.payment_status === 'pending' && !o.is_paid,
      );
    } else if (filter === 'failed') {
      filtered = filtered.filter((o) => o.payment_status === 'failed');
    }

    if (searchTerm) {
      filtered = filtered.filter((o) => {
        const productName = o.items?.[0]?.product_name?.toLowerCase() || '';
        const ref = o.reference?.toLowerCase() || '';
        const id = o.id?.toString() || '';
        const search = searchTerm.toLowerCase();
        return (
          productName.includes(search) ||
          ref.includes(search) ||
          id.includes(search)
        );
      });
    }

    return filtered;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-KE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const formatCurrency = (amount) => `KSh ${Number(amount).toLocaleString()}`;

  const getProductName = (items) => {
    if (!items || items.length === 0) return 'Order';
    return items[0].product_name || 'Order';
  };

  const getTotalItems = (items) => {
    if (!items) return 0;
    return items.reduce((sum, item) => sum + item.quantity, 0);
  };

  const downloadPDF = async (orderId) => {
    if (!orderId) {
      toast.error('No order selected. Please try again.');
      return;
    }

    setDownloadingOrderId(orderId);
    setPdfLoading(true);

    try {
      const response = await serverUrlAuth.get(`checkout/${orderId}/receipt/`);

      const container = document.createElement('div');
      container.innerHTML = response.data;
      container.style.position = 'fixed';
      container.style.left = '-9999px';
      container.style.top = '-9999px';
      container.style.width = '800px';
      container.style.background = '#ffffff';
      container.style.zIndex = '-1000';
      container.style.padding = '20px';
      document.body.appendChild(container);

      const images = container.querySelectorAll('img');
      await Promise.all(
        Array.from(images).map(
          (img) =>
            new Promise((resolve) => {
              if (img.complete) resolve();
              else {
                img.onload = resolve;
                img.onerror = resolve;
              }
            }),
        ),
      );

      const canvas = await html2canvas(container, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        allowTaint: true,
      });

      const imgData = canvas.toDataURL('image/jpeg', 1);
      const pdf = new jsPDF({
        unit: 'px',
        format: [canvas.width, canvas.height],
      });

      pdf.addImage(
        imgData,
        'JPEG',
        0,
        0,
        canvas.width,
        canvas.height,
        undefined,
        'FAST',
      );

      const order = orders.find((o) => o.id === orderId);
      const receiptNumber = order?.receipt_number || orderId;
      pdf.save(`receipt-${receiptNumber}.pdf`);

      document.body.removeChild(container);
      toast.success('PDF downloaded successfully!');
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Failed to generate PDF');
    } finally {
      setPdfLoading(false);
      setDownloadingOrderId(null);
    }
  };

  const filteredOrders = getFilteredOrders();

  const stats = {
    total: orders.length,
    paid: orders.filter((o) => o.is_paid).length,
    pending: orders.filter((o) => o.payment_status === 'pending' && !o.is_paid)
      .length,
    failed: orders.filter((o) => o.payment_status === 'failed').length,
    totalAmount: orders.reduce(
      (sum, o) => sum + (o.is_paid ? parseFloat(o.total || 0) : 0),
      0,
    ),
  };

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard orders-shell">
        <div className="orders-page-modern">
          {/* Hero */}
          <header className="hero-craftsmanship">
            <div className="hero-pattern"></div>
            <div className="hero-content-modern">
              <div className="welcome-badge">
                <FaShoppingBag className="badge-icon" />
                <span>Order History</span>
              </div>
              <h1 className="hero-title">
                <span className="gradient-text">My</span>
                <span className="hero-accent">Orders</span>
              </h1>
              <p className="hero-subtitle">
                Track all your orders and purchases in one place. View
                receipts, download invoices, and manage your order history.
              </p>
            </div>
          </header>

          {/* Stats */}
          <div className="stats-dashboard-modern">
            <div className="stat-card-modern">
              <div className="stat-icon-wrapper accent-brand">
                <FaShoppingBag />
              </div>
              <div className="stat-content">
                <h3>{stats.total}</h3>
                <p>Total Orders</p>
              </div>
            </div>
            <div className="stat-card-modern">
              <div className="stat-icon-wrapper accent-olive">
                <FaCheckCircle />
              </div>
              <div className="stat-content">
                <h3>{stats.paid}</h3>
                <p>Completed</p>
              </div>
            </div>
            <div className="stat-card-modern">
              <div className="stat-icon-wrapper accent-gold">
                <FaClock />
              </div>
              <div className="stat-content">
                <h3>{stats.pending}</h3>
                <p>Pending</p>
              </div>
            </div>
            <div className="stat-card-modern">
              <div className="stat-icon-wrapper accent-info">
                <FaMoneyBillWave />
              </div>
              <div className="stat-content">
                <h3>{formatCurrency(stats.totalAmount)}</h3>
                <p>Total Spent</p>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className="orders-controls-modern">
            <div className="search-bar-modern">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search by product, order ID, or reference..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  className="clear-search"
                  onClick={() => setSearchTerm('')}
                  aria-label="Clear search"
                >
                  ×
                </button>
              )}
            </div>
            <div className="filter-tabs-modern">
              <button
                className={`filter-tab ${filter === 'all' ? 'active' : ''}`}
                onClick={() => setFilter('all')}
              >
                All
              </button>
              <button
                className={`filter-tab ${filter === 'paid' ? 'active' : ''}`}
                onClick={() => setFilter('paid')}
              >
                ✅ Completed
              </button>
              <button
                className={`filter-tab ${filter === 'pending' ? 'active' : ''}`}
                onClick={() => setFilter('pending')}
              >
                ⏳ Pending
              </button>
              <button
                className={`filter-tab ${filter === 'failed' ? 'active' : ''}`}
                onClick={() => setFilter('failed')}
              >
                ❌ Failed
              </button>
            </div>
            <button className="refresh-btn-modern" onClick={fetchOrderHistory}>
              <FaSpinner className={loading ? 'spinning' : ''} />
              Refresh
            </button>
          </div>

          {/* Orders Grid */}
          <div className="orders-grid-modern">
            {loading ? (
              <div className="orders-loading-modern full-width">
                <div className="spinner-modern"></div>
                <p>Loading your orders...</p>
              </div>
            ) : filteredOrders.length === 0 ? (
              <div className="empty-state-modern full-width">
                <div className="empty-icon">🛒</div>
                <h3>No orders found</h3>
                <p>
                  {searchTerm || filter !== 'all'
                    ? 'No orders match your search criteria'
                    : "You haven't placed any orders yet"}
                </p>
                {!searchTerm && filter === 'all' && (
                  <Link to="/ready-made-products" className="btn-primary-custom">
                    Start Shopping
                  </Link>
                )}
              </div>
            ) : (
              filteredOrders.map((order) => (
                <div key={order.id} className="order-card-modern">
                  <div className="order-card-header">
                    <div className="order-product-section">
                      <div className="product-icon-wrapper">
                        <FaBox />
                      </div>
                      <div className="product-details">
                        <h4>{getProductName(order.items)}</h4>
                        <div className="order-meta">
                          <span className="order-id">Order #{order.id}</span>
                          <span className="divider">•</span>
                          <span className="item-count">
                            {getTotalItems(order.items)} item
                            {getTotalItems(order.items) !== 1 ? 's' : ''}
                          </span>
                          <span className="divider">•</span>
                          <span className="order-ref">
                            {order.reference || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="order-status-badge">
                      {getStatusBadge(order.payment_status, order.is_paid)}
                    </div>
                  </div>

                  <div className="order-card-body">
                    <div className="order-date-info">
                      <FaCalendar />
                      <span>{formatDate(order.created_at)}</span>
                    </div>
                    <div className="order-total-info">
                      <span className="label">Total</span>
                      <span className="amount">
                        {formatCurrency(order.total)}
                      </span>
                    </div>
                  </div>

                  <div className="order-card-footer">
                    <button
                      className="btn-view"
                      onClick={() => fetchOrderDetails(order.id)}
                    >
                      <FaEye /> View Details
                    </button>
                    {order.is_paid && (
                      <button
                        className="btn-receipt"
                        onClick={() => downloadPDF(order.id)}
                        disabled={pdfLoading && downloadingOrderId === order.id}
                      >
                        {pdfLoading && downloadingOrderId === order.id ? (
                          <>
                            <FaSpinner className="spinning" /> Generating...
                          </>
                        ) : (
                          <>
                            <FaDownload /> Download PDF
                          </>
                        )}
                      </button>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Order Details Modal */}
          <Modal
            show={showModal}
            onHide={() => {
              setShowModal(false);
              setSelectedOrder(null);
            }}
            centered
            size="lg"
            className="order-details-modal-modern"
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <span className="modal-title-icon">📋</span>
                Order #{selectedOrder?.order_id}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {modalLoading ? (
                <div className="modal-loading">
                  <div className="spinner-small"></div>
                  <p>Loading order details...</p>
                </div>
              ) : (
                selectedOrder && (
                  <div className="order-details-content">
                    <div className="detail-status-bar">
                      {getStatusBadge(
                        selectedOrder.payment_status,
                        selectedOrder.is_paid,
                      )}
                      {selectedOrder.receipt_number && (
                        <span className="receipt-number">
                          <FaReceipt /> #{selectedOrder.receipt_number}
                        </span>
                      )}
                    </div>

                    <div className="detail-grid-modern">
                      <div className="detail-item">
                        <label>Order ID</label>
                        <p>#{selectedOrder.order_id}</p>
                      </div>
                      <div className="detail-item">
                        <label>Reference</label>
                        <p>{selectedOrder.reference || 'N/A'}</p>
                      </div>
                      <div className="detail-item">
                        <label>Date</label>
                        <p>{formatDate(selectedOrder.created_at)}</p>
                      </div>
                      <div className="detail-item">
                        <label>Status</label>
                        <p>{selectedOrder.is_paid ? '✅ Paid' : '⏳ Pending'}</p>
                      </div>
                    </div>

                    <div className="detail-items-section">
                      <h4>Items Ordered</h4>
                      <div className="items-table">
                        <div className="items-header">
                          <span>Product</span>
                          <span>Qty</span>
                          <span>Price</span>
                          <span>Total</span>
                        </div>
                        {selectedOrder.items?.map((item, index) => (
                          <div key={index} className="items-row">
                            <span className="product-name">
                              {item.product_name}
                            </span>
                            <span className="product-qty">{item.quantity}</span>
                            <span className="product-price">
                              {formatCurrency(item.price)}
                            </span>
                            <span className="product-total">
                              {formatCurrency(item.total)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="detail-totals">
                      <div className="total-row">
                        <span>Subtotal</span>
                        <span>{formatCurrency(selectedOrder.subtotal)}</span>
                      </div>
                      <div className="total-row">
                        <span>VAT (16%)</span>
                        <span>{formatCurrency(selectedOrder.vat_amount)}</span>
                      </div>
                      <div className="total-row grand-total">
                        <span>Total</span>
                        <span>{formatCurrency(selectedOrder.total)}</span>
                      </div>
                    </div>

                    <div className="detail-shipping">
                      <h4>Shipping Address</h4>
                      <p>{selectedOrder.shipping_address}</p>
                      <p className="phone">📞 {selectedOrder.phone_number}</p>
                    </div>
                  </div>
                )
              )}
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn-secondary"
                onClick={() => {
                  setShowModal(false);
                  setSelectedOrder(null);
                }}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default withAuth(OrderHistoryPage, 'client');